export function Pager(pagingContainer, onClick) {
    this.defaultPageIdx = 0;
    this.defaultPageCount = 10;

    this.container = pagingContainer;
    this.idx = this.defaultPageIdx;
    this.count = this.defaultPageCount;
    this.total = 0;

    this.previous = pagingContainer.getElementsByClassName('page-left')[0];
    this.next = pagingContainer.getElementsByClassName('page-right')[0];

    const self = this;

    this.previous.addEventListener('click', function () {
        if (this.getAttribute('disabled')) {
            return false;
        }

        self.idx -= self.count;

        if (self.idx < 0)
            self.idx = 0;

        onClick(self.idx, self.count);
    });

    this.next.addEventListener('click', function () {
        if (this.getAttribute('disabled')) {
            return false;
        }

        self.idx += self.count;

        if (self.idx > self.total)
            self.idx -= self.count;

        onClick(self.idx, self.count);
    });

    this.update = function (idx, count, total) {
        this.idx = idx;
        this.count = count;
        this.total = total;

        if (this.idx + this.count >= total) {
            self.next.setAttribute('disabled', 'true');
        } else {
            self.next.removeAttribute('disabled');
        }

        if (this.idx <= 0) {
            self.previous.setAttribute('disabled', 'true');
        } else {
            self.previous.removeAttribute('disabled');
        }
    };

    this.toggleControls = function (show) {
        if (show) {
            self.container.className = 'pager-container';
        } else {
            self.container.className = 'pager-container hidden';
        }
    };

    this.reset = function () {
        this.idx = this.defaultPageIdx;
        this.count = this.defaultPageCount;
        this.total = 0;
    }
}